import { Link } from 'react-router-dom';

import { Image } from 'antd';

import User from '../pages/user/User';
import AddUpdateUser from '../pages/user/AddUpdateUser';
import CheckMail from '../pages/auth/CheckMail';
import ForgotPassword from '../pages/auth/ForgotPassword';
import ResetPassword from '../pages/auth/ResetPassword';
import SignIn from '../pages/auth/SignIn';
import VerifyOTP from '../pages/auth/VerifyOTP';
import SetPassword from '../pages/auth/SetPassword';
import WelcomePage from '../pages/auth/WelcomePage';
import UserType from '../pages/user-type/UserType';
import UpdateUserType from '../pages/user-type/UpdateUserType';
import Packages from '../pages/packages/Packages';
import AddUpdatePackages from '../pages/packages/AddUpdatePackages';
import TokenAdmin from '../pages/token-admin/TokenAdmin';
import VerifyEmail from '../pages/auth/VerifyEmail';
import Administrator from '../pages/administrator/Administrator';
import AddUpdateAdministrator from '../pages/administrator/AddUpdateAdministrator';
import Designation from '../pages/designation/Designation';
import ProfileSettings from '../pages/settings/ProfileSettings';
import Stammdaten from '../pages/stammdaten/Stammdaten';
import WarehouseManagement from '../pages/warehouse/WarehouseManagement';
import AddUdateWarehouse from '../pages/warehouse/AddUdateWarehouse';
import Lagar from '../pages/lagar-management/Lagar';
import TimeTracking from '../pages/time-tracking';
import City from '../pages/city/City';

import dashboardIcon from '../assets/images/dashboard.svg';
import userManagementIcon from '../assets/images/user-management.svg';
import administratorManagementIcon from '../assets/images/administrator-management.svg';
import packageIcon from '../assets/images/packages.svg';
import stammdatenIcon from '../assets/images/stammdaten.svg';
import whIcon from '../assets/images/WhIcon.svg';
import timeTrackingIcon from '../assets/images/timeTrackingIcon.svg'
import profileSettingsIcon from '../assets/images/profile-settings.svg';
import constructionDiaryIcon from '../assets/images/constructionDiaryIcon.svg';
import vacationManagementIcon from '../assets/images/vacationManagementIcon.svg';
import utilityIcon from '../assets/images/utilityIcon.svg';
import watchTimeIcon from '../assets/images/watch-time.svg';
import handshakeIcon from '../assets/images/handshake.svg';
import ConstructionDiary from '../pages/construction-diary/ConstructionDiary';
import AddConstructionDiary from '../pages/construction-diary/AddConstructionDiary';
import AddUpdateNewVacation from '../pages/settings/AddUpdateNewVacation';
import VacationManagement from '../pages/vacation-management/Index';
import WorkHistory from '../pages/settings/WorkHistory';
import AddNewVacation from '../pages/settings/AddNewVacation';
import GeneralInformation from '../pages/stammdaten/GeneralInformation';
import Project from '../pages/stammdaten/Project';
import Documents from '../pages/stammdaten/Documents';
import CompanyDetails from '../pages/settings/CompanyDetails';
import AiSettings from '../pages/settings/AiSettings';
import InventoryManagement from '../pages/inventory-management/InventoryManagement';
import EquipmentManagement from '../pages/equipment-management/EquipmentManagement';
import EquipmentHistory from '../pages/equipment-management/EquipmentHistory';
import AllUserTimeTracking from '../pages/time-tracking/all-user-time-tracking';
import IndividualTimeTracking from '../pages/time-tracking/individual-time-tracking';
import AllLeaves from '../pages/vacation-management/all-leaves';
import AllLeavesAdmin from '../pages/vacation-management/all-leaves-admin/Index';
import AddLeave from '../pages/vacation-management/add-leave';
import RequestLeave from '../pages/vacation-management/request-leave';
import Dashboard from '../pages/dashboard/Dashboard';
import DatevExport from '../pages/datev-export/Index';
import BirthdayCalendar from '../pages/birthday-calendar/BirthdayCalendar';
import SupporterfassungPage from '../pages/support-tracking/SupporterfassungPage';
import SupportVerlaufPage from '../pages/support-tracking/SupportVerlaufPage';
import SupportTaetigkeitenPage from '../pages/support-tracking/SupportTaetigkeitenPage';
import SupportEinstellungenPage from '../pages/support-tracking/SupportEinstellungenPage';
import ContractDashboard from '../pages/contract-manager/ContractDashboard';
import ContractList from '../pages/contract-manager/ContractList';
import AddUpdateContract from '../pages/contract-manager/AddUpdateContract';
import ContractDetail from '../pages/contract-manager/ContractDetail';
import ContractCategories from '../pages/contract-manager/ContractCategories';
import ContractCalendar from '../pages/contract-manager/ContractCalendar';
import ContractAiReview from '../pages/contract-manager/ContractAiReview';
import ContractChat from '../pages/contract-manager/ContractChat';

export const privateRoutes = [
    {
        to: '/dashboard',
        element: <Dashboard />,
        children: [],
        label: <Link to='/dashboard'>Dashboard</Link>,
        germanLabel: <Link to='/dashboard'>Dashboard</Link>,
        translationKey: 'menu_dashboard',
        linkTo: '/dashboard',
        key: '1',
        menu: 'Dashboard',
        icon: <Image src={dashboardIcon} preview={false} width={20} height={20} />,
    },
    {
        to: '/user',
        label: 'User Mgnt.',
        germanLabel: 'Benutzerverwaltung',
        translationKey: 'menu_user_mgnt',
        key: '2',
        menu: 'User Mgnt.',
        icon: <Image src={userManagementIcon} preview={false} width={20} height={20} />,
        children: [
            {
                to: '',
                element: <User />,
                label: <Link to='/user'>Users</Link>,
                germanLabel: <Link to='/user'>Benutzer</Link>,
                translationKey: 'menu_user_mgnt_users',
                linkTo: '/user',
                menu: 'Users',
                key: '21'
            },
            {
                to: 'add',
                element: <AddUpdateUser />,
                label: false,
                menu: 'Users',
            },
            {
                to: 'edit/:id',
                element: <AddUpdateUser />,
                label: false,
                menu: 'Users',
            },
            {
                to: 'type',
                label: <Link to='/user/type'>User Type</Link>,
                germanLabel: <Link to='/user/type'>Benutzertyp</Link>,
                translationKey: 'menu_user_mgnt_user_type',
                linkTo: '/user/type',
                menu: 'User Types',
                key: '22',
                element: <UserType />
            },
            {
                to: 'type/add',
                label: false,
                menu: 'User Types',
                element: <UpdateUserType />
            },
            {
                to: 'type/edit/:id',
                label: false,
                menu: 'User Types',
                element: <UpdateUserType />
            },
            {
                to: 'designation',
                label: <Link to='/user/designation'>Designation</Link>,
                germanLabel: <Link to='/user/designation'>Bezeichnung</Link>,
                translationKey: 'menu_user_mgnt_designations',
                linkTo: '/user/designation',
                menu: 'Designations',
                key: '23',
                element: <Designation />,
            },
            {
                to: 'birthday-calendar',
                label: <Link to='/user/birthday-calendar'>Birthday Calendar</Link>,
                germanLabel: <Link to='/user/birthday-calendar'>Geburtstagskalender</Link>,
                translationKey: 'menu_birthday_calendar',
                linkTo: '/user/birthday-calendar',
                menu: 'Birthday Calendar',
                key: '24',
                element: <BirthdayCalendar />,
            },
        ],
    },
    {
        to: '/client',
        element: <Administrator />,
        children: [],
        label: <Link to='/client'>Client</Link>,
        germanLabel: <Link to='/client'>Kunde</Link>,
        translationKey: 'menu_client_mgnt',
        linkTo: '/client',
        key: '3',
        menu: 'Client',
        icon: <Image src={administratorManagementIcon} preview={false} width={20} height={20} />
    },
    {
        to: '/client/add',
        element: <AddUpdateAdministrator />,
        label: false,
        menu: 'Client',
        children: [],
    },
    {
        to: '/client/edit/:id',
        element: <AddUpdateAdministrator />,
        label: false,
        menu: 'Client',
        children: [],
    },
    {
        to: '/packages',
        element: <Packages />,
        children: [],
        label: <Link to='/packages'>Packages</Link>,
        germanLabel: <Link to='/packages'>Pakete</Link>,
        translationKey: 'menu_packages',
        linkTo: '/packages',
        key: '4',
        menu: 'Packages',
        icon: <Image src={packageIcon} preview={false} width={20} height={20} />
    },
    {
        to: '/packages/add',
        element: <AddUpdatePackages />,
        label: false,
        menu: 'Packages',
        children: [],
    },
    {
        to: '/packages/edit/:id',
        label: false,
        menu: 'Packages',
        element: <AddUpdatePackages />,
        children: [],
    },
    {
        to: '/token-admin',
        element: <TokenAdmin />,
        children: [],
        label: <Link to='/token-admin'>KI Token-Mgnt.</Link>,
        germanLabel: <Link to='/token-admin'>KI Token-Mgnt.</Link>,
        translationKey: 'menu_token_admin',
        linkTo: '/token-admin',
        key: '4b',
        menu: 'Token Admin',
        icon: <Image src={packageIcon} preview={false} width={20} height={20} />,
    },
    {
        to: '/stammdaten',
        label: 'Stammdaten',
        germanLabel: 'Stammdaten',
        translationKey: 'menu_stammdaten',
        key: '5',
        menu: 'Stammdaten',
        icon: <Image src={stammdatenIcon} preview={false} width={20} height={20} />,
        children: [
            {
                to: '',
                element: <Stammdaten />,
                label: <Link to='/stammdaten'>Customer</Link>,
                germanLabel: <Link to='/stammdaten'>Kunde</Link>,
                translationKey: 'menu_stammdaten_customer',
                linkTo: '/stammdaten',
                menu: 'User',
                key: '51'
            },
            {
                to: 'add',
                element: <GeneralInformation />,
                label: false,
                menu: 'User',
            },
            {
                to: 'edit/:id',
                element: <GeneralInformation />,
                label: false,
                menu: 'User',
            },
            {
                to: 'project',
                element: <Project />,
                label: <Link to='/stammdaten/project'>Project</Link>,
                germanLabel: <Link to='/stammdaten/project'>Projekt</Link>,
                translationKey: 'menu_stammdaten_projects',
                linkTo: '/stammdaten/project',
                menu: 'Projects',
                key: '52'
            },
            {
                to: 'document',
                element: <Documents />,
                label: <Link to='/stammdaten/document'>Document</Link>,
                germanLabel: <Link to='/stammdaten/document'>Dokumente</Link>,
                translationKey: 'menu_stammdaten_documents',
                linkTo: '/stammdaten/document',
                menu: 'Documents',
                key: '53'
            },
        ],
    },
    {
        to: 'warehouse-management',
        label: 'Warehouse Mgmt.',
        germanLabel: 'Lagerverwaltung',
        translationKey: 'menu_warehouse_mgnt',
        key: '6',
        menu: 'Warehouse Mgnt.',
        icon: <Image src={whIcon} preview={false} width={20} height={20} />,
        children: [
            {
                to: 'lager',
                element: <Lagar />,
                label: <Link to='/warehouse-management/lager'>Lager</Link>,
                germanLabel: <Link to='/warehouse-management/lager'>Lager</Link>,
                translationKey: 'menu_warehouse_mgnt_lager',
                linkTo: '/warehouse-management/lager',
                menu: 'Lager',
                key: '61'
            },
            {
                to: 'wh-place',
                element: <WarehouseManagement />,
                label: <Link to='/warehouse-management/wh-place'>WH Place Mgmt.</Link>,
                germanLabel: <Link to='/warehouse-management/wh-place'>Platzverwaltung</Link>,
                translationKey: 'menu_warehouse_mgnt_wh_place_management',
                linkTo: '/warehouse-management/wh-place',
                menu: 'WH Place Management',
                key: '62'
            },
            {
                to: 'wh-place/add',
                element: <AddUdateWarehouse />,
                label: false,
                menu: 'WH Place Management',
            },
            {
                to: 'wh-place/edit/:id',
                element: <AddUdateWarehouse />,
                label: false,
                menu: 'WH Place Management',
            },
            {
                to: "inventory-management",
                element: <InventoryManagement />,
                label: <Link to='/warehouse-management/inventory-management'>Inventory Mgmt.</Link>,
                germanLabel: <Link to='/warehouse-management/inventory-management'>Bestandsverwaltung</Link>,
                translationKey: 'menu_warehouse_mgnt_inventory_mgmt',
                linkTo: '/warehouse-management/inventory-management',
                menu: "Inventory Mgmt.",
                key: '63'
            },
            {
                to: 'equipment-list',
                element: <EquipmentManagement />,
                label: <Link to='/warehouse-management/equipment-list'>Equipment List</Link>,
                germanLabel: <Link to='/warehouse-management/equipment-list'>Ausrüstungsliste</Link>,
                translationKey: 'menu_warehouse_mgnt_equipment_list',
                linkTo: '/warehouse-management/equipment-list',
                menu: 'Equipment list',
                key: '64'
            },
            {
                to: 'equipment-history',
                element: <EquipmentHistory />,
                label: <Link to='/warehouse-management/equipment-history'>Equipment History</Link>,
                germanLabel: <Link to='/warehouse-management/equipment-history'>Ausrüstungsgeschichte</Link>,
                translationKey: 'menu_warehouse_mgnt_equipment_history',
                linkTo: '/warehouse-management/equipment-history',
                menu: 'Equipment History',
                key: '65'
            },
        ]
    },
    {
        to: '/time-tracking',
        label: 'Time Tracking Mgmt.',
        germanLabel: 'Zeiterfassung',
        translationKey: 'menu_time_tracking',
        key: '7',
        menu: 'Time Tracking',
        icon: <Image src={timeTrackingIcon} preview={false} width={20} height={20} />,
        children: [
            {
                to: 'work-history',
                element: <WorkHistory />,
                label: <Link to='/time-tracking/work-history'>Work History</Link>,
                germanLabel: <Link to='/time-tracking/work-history'>Meine Zeiten</Link>,
                translationKey: 'menu_settings_work_history',
                linkTo: '/time-tracking/work-history',
                menu: 'Work History',
                key: '73'
            },
            {
                to: 'all-user-time-tracking',
                element: <AllUserTimeTracking />,
                label: <Link to='/time-tracking/all-user-time-tracking'>All User Time Tracking</Link>,
                germanLabel: <Link to='/time-tracking/all-user-time-tracking'>Alle Benutzer</Link>,
                translationKey: 'organizer_timetracking_allusertimetracking',
                linkTo: '/time-tracking/all-user-time-tracking',
                menu: 'All User Time Tracking',
                key: '71'
            },
            {
                to: 'individual-time-tracking',
                element: <IndividualTimeTracking />,
                label: <Link to='/time-tracking/individual-time-tracking'>Individual Time Tracking</Link>,
                germanLabel: <Link to='/time-tracking/individual-time-tracking'>Pro Mitarbeiter</Link>,
                translationKey: 'organizer_timetracking_individualtimetracking',
                linkTo: '/time-tracking/individual-time-tracking',
                menu: 'Individual Time Tracking',
                key: '72'
            },
            {
                to: 'datev-export',
                element: <DatevExport />,
                label: <Link to='/time-tracking/datev-export'>DATEV Export</Link>,
                germanLabel: <Link to='/time-tracking/datev-export'>DATEV Export</Link>,
                translationKey: 'menu_datev_export',
                linkTo: '/time-tracking/datev-export',
                menu: 'DATEV Export',
                key: '74'
            },
        ],
    },
    {
        to: '/construction-diary',
        element: <ConstructionDiary />,
        children: [],
        label: <Link to='/construction-diary'>Construction Diary</Link>,
        germanLabel: <Link to='/construction-diary'>Bautagebuch</Link>,
        translationKey: 'menu_construction_diary',
        linkTo: '/construction-diary',
        key: '9',
        menu: 'Construction Diary',
        icon: <Image src={constructionDiaryIcon} preview={false} width={20} height={20} />
    },
    {
        to: '/construction-diary/add',
        element: <AddConstructionDiary />,
        children: [],
        label: false,
        menu: 'Construction Diary',
    },
    {
        to: '/vacation-management',
        label: 'Vacation Mgmt.',
        germanLabel: 'Urlaubsmanagement',
        translationKey: 'menu_vacation_mgnt',
        key: '10',
        menu: 'Vacation Mgnt.',
        icon: <Image src={vacationManagementIcon} preview={false} width={20} height={20} />,
        children: [
            {
                to: 'all-leaves',
                element: <AllLeaves />,
                label: <Link to='/vacation-management/all-leaves'>All Leaves</Link>,
                germanLabel: <Link to='/vacation-management/all-leaves'>Alle Urlaube</Link>,
                translationKey: 'organizer_vacationmanagement_all_leaves',
                linkTo: '/vacation-management/all-leaves',
                menu: 'All Leaves',
                key: '101'
            },
            {
                to: 'all-leaves-admin',
                element: <AllLeavesAdmin />,
                label: <Link to='/vacation-management/all-leaves-admin'>All Leaves Admin</Link>,
                germanLabel: <Link to='/vacation-management/all-leaves-admin'>Alle Urlaube Admin</Link>,
                translationKey: 'organizer_vacationmanagement_all_leaves',
                linkTo: '/vacation-management/all-leaves-admin',
                menu: 'All Leaves Admin',
                key: '102'
            },
            {
                to: 'add-leave',
                element: <AddLeave />,
                label: <Link to='/vacation-management/add-leave'>Add leave</Link>,
                germanLabel: <Link to='/vacation-management/add-leave'>Urlaub hinzufügen</Link>,
                translationKey: 'organizer_vacationmanagement_leave',
                linkTo: '/vacation-management/add-leave',
                menu: 'Add Leave',
                key: '103'
            },
            {
                to: 'requested-leave',
                element: <RequestLeave />,
                label: <Link to='/vacation-management/requested-leave'>Requested leave</Link>,
                germanLabel: <Link to='/vacation-management/requested-leave'>Beantragte Urlaub</Link>,
                translationKey: 'organizer_vacationmanagement_requested',
                linkTo: '/vacation-management/requested-leave',
                menu: 'Requested Leave',
                key: '104'
            },
            {
                to: 'add-new-Vacation',
                element: <AddNewVacation />,
                label: <Link to='/vacation-management/add-new-vacation'>Add New Vacation</Link>,
                germanLabel: <Link to='/vacation-management/add-new-vacation'>Neuen Urlaub hinzufügen</Link>,
                translationKey: 'menu_settings_add_vacation',
                linkTo: '/vacation-management/add-new-vacation',
                menu: 'Add Vacation',
                key: '93',
            },
            {
                to: 'add-new-Vacation/add',
                element: <AddUpdateNewVacation />,
                label: false,
                menu: 'Add Vacation',
            },
            {
                to: 'add-new-Vacation/edit/:id',
                element: <AddUpdateNewVacation />,
                label: false,
                menu: 'Add Vacation',
            },
        ],
    },
    {
        to: '/support-tracking',
        label: 'Ticket-Erfassung',
        germanLabel: 'Ticket-Erfassung',
        translationKey: 'menu_support_tracking',
        key: '13',
        menu: 'Support-Zeiterfassung',
        icon: <Image src={watchTimeIcon} preview={false} width={20} height={20} />,
        children: [
            {
                to: 'erfassung',
                element: <SupporterfassungPage />,
                label: <Link to='/support-tracking/erfassung'>Erfassung</Link>,
                germanLabel: <Link to='/support-tracking/erfassung'>Erfassung</Link>,
                translationKey: 'menu_support_erfassung',
                linkTo: '/support-tracking/erfassung',
                menu: 'Erfassung',
                key: '131',
            },
            {
                to: 'verlauf',
                element: <SupportVerlaufPage />,
                label: <Link to='/support-tracking/verlauf'>Verlauf</Link>,
                germanLabel: <Link to='/support-tracking/verlauf'>Verlauf</Link>,
                translationKey: 'menu_support_verlauf',
                linkTo: '/support-tracking/verlauf',
                menu: 'Verlauf',
                key: '132',
            },
            {
                to: 'taetigkeiten',
                element: <SupportEinstellungenPage />,
                label: <Link to='/support-tracking/taetigkeiten'>Einstellungen</Link>,
                germanLabel: <Link to='/support-tracking/taetigkeiten'>Einstellungen</Link>,
                translationKey: 'menu_support_einstellungen',
                linkTo: '/support-tracking/taetigkeiten',
                menu: 'Tätigkeiten',
                key: '133',
            },
        ],
    },
    {
        to: '/settings',
        label: "Settings",
        germanLabel: "Einstellungen",
        translationKey: 'menu_settings',
        key: '12',
        menu: "Settings",
        icon: <Image src={profileSettingsIcon} preview={false} width={20} height={20} />,
        children: [
            {
                to: 'general',
                element: <ProfileSettings />,
                label: <Link to='/settings/general'>General Setting</Link>,
                germanLabel: <Link to='/settings/general'>Allgemeine Einstellung</Link>,
                translationKey: 'menu_settings_general_setting',
                linkTo: '/settings/general',
                menu: 'General Setting',
                key: '121'
            },
            {
                to: 'company-details',
                element: <CompanyDetails />,
                label: <Link to={'/settings/company-details'}>Company Details</Link>,
                germanLabel: <Link to={'/settings/company-details'}>Firmendetails</Link>,
                translationKey: 'menu_settings_company_detail',
                linkTo: '/settings/company-details',
                menu: 'Company Detail',
                key: '122'
            },
            {
                to: 'city',
                element: <City />,
                label: <Link to='/settings/city'>City</Link>,
                germanLabel: <Link to='/settings/city'>Stadt</Link>,
                translationKey: 'menu_utility_city',
                linkTo: '/settings/city',
                menu: 'City',
                key: '123'
            },
            {
                to: 'ai-settings',
                element: <AiSettings />,
                label: <Link to='/settings/ai-settings'>KI-Einstellungen</Link>,
                germanLabel: <Link to='/settings/ai-settings'>KI-Einstellungen</Link>,
                translationKey: 'menu_settings_ai',
                linkTo: '/settings/ai-settings',
                menu: 'KI-Einstellungen',
                key: '124'
            },
        ],
    },
    {
        to: '/contract-manager',
        label: 'Vertragsmanager',
        germanLabel: 'Vertragsmanager',
        translationKey: 'menu_contract_manager',
        key: '14',
        menu: 'Vertragsmanager',
        icon: <Image src={handshakeIcon} preview={false} width={20} height={20} />,
        children: [
            {
                to: '',
                element: <ContractDashboard />,
                label: <Link to='/contract-manager'>Dashboard</Link>,
                germanLabel: <Link to='/contract-manager'>Dashboard</Link>,
                translationKey: 'menu_contract_dashboard',
                linkTo: '/contract-manager',
                menu: 'Contract Dashboard',
                key: '141'
            },
            {
                to: 'list',
                element: <ContractList />,
                label: <Link to='/contract-manager/list'>Verträge</Link>,
                germanLabel: <Link to='/contract-manager/list'>Verträge</Link>,
                translationKey: 'menu_contract_list',
                linkTo: '/contract-manager/list',
                menu: 'Contract List',
                key: '142'
            },
            {
                to: 'add',
                element: <AddUpdateContract />,
                label: false,
                menu: 'Contract List',
            },
            {
                to: 'edit/:id',
                element: <AddUpdateContract />,
                label: false,
                menu: 'Contract List',
            },
            {
                to: 'detail/:id',
                element: <ContractDetail />,
                label: false,
                menu: 'Contract List',
            },
            {
                to: 'calendar',
                element: <ContractCalendar />,
                label: <Link to='/contract-manager/calendar'>Fristen</Link>,
                germanLabel: <Link to='/contract-manager/calendar'>Fristen</Link>,
                translationKey: 'menu_contract_calendar',
                linkTo: '/contract-manager/calendar',
                menu: 'Contract Calendar',
                key: '143'
            },
            {
                to: 'categories',
                element: <ContractCategories />,
                label: <Link to='/contract-manager/categories'>Kategorien</Link>,
                germanLabel: <Link to='/contract-manager/categories'>Kategorien</Link>,
                translationKey: 'menu_contract_categories',
                linkTo: '/contract-manager/categories',
                menu: 'Contract Categories',
                key: '144'
            },
            {
                to: 'ai',
                element: <ContractAiReview />,
                label: <Link to='/contract-manager/ai'>KI-Import</Link>,
                germanLabel: <Link to='/contract-manager/ai'>KI-Import</Link>,
                translationKey: 'menu_contract_ai',
                linkTo: '/contract-manager/ai',
                menu: 'Contract AI',
                key: '145'
            },
            {
                to: 'ai/:id',
                element: <ContractAiReview />,
                label: false,
                menu: 'Contract AI',
            },
            {
                to: 'chat',
                element: <ContractChat />,
                label: <Link to='/contract-manager/chat'>KI-Chat</Link>,
                germanLabel: <Link to='/contract-manager/chat'>KI-Chat</Link>,
                translationKey: 'menu_contract_chat',
                linkTo: '/contract-manager/chat',
                menu: 'Contract Chat',
                key: '146'
            },
        ],
    },
];

export const publicRoutes = [
    {
        to: 'user/authentication/sign-in',
        element: <SignIn />
    },
    {
        to: 'user/authentication/forgot-password',
        element: <ForgotPassword />
    },
    {
        to: 'user/authentication/verify-otp/:id',
        element: <VerifyOTP />
    },
    {
        to: 'user/authentication/reset-password/:id/:token',
        element: <ResetPassword />
    },
    {
        to: 'user/authentication/check-email',
        element: <CheckMail />
    },
    {
        to: 'user/authentication/set-password',
        element: <SetPassword />
    },
    {
        to: 'user/welcome',
        element: <WelcomePage />
    },
    {
        to: 'user/authentication/verify-email/:id/:token',
        element: <VerifyEmail />
    }
];